import React, { useEffect, useRef, useState } from 'react'
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '../TiptapEditor/components/tiptap-ui-primitive/tooltip'
import styles from './index.module.scss'

interface OverflowTooltipProps {
    text: string
    className?: string
}

export default function OverflowTooltip({ text, className }: OverflowTooltipProps) {
    const textRef = useRef<HTMLSpanElement>(null)
    const [isOpen, setIsOpen] = useState(false)

    const hideTooltip = () => setIsOpen(false)

    const showTooltipIfTruncated = () => {
        const node = textRef.current
        if (!node) return

        const isTruncated = node.scrollWidth > node.clientWidth + 1
            || node.scrollHeight > node.clientHeight + 1

        if (!isTruncated) {
            hideTooltip()
            return
        }

        setIsOpen(true)
    }

    useEffect(() => {
        hideTooltip()
    }, [text])

    return (
        <Tooltip open={isOpen} onOpenChange={setIsOpen} placement="top" delay={0}>
            <TooltipTrigger asChild>
                <span
                    ref={textRef}
                    className={className}
                    onMouseEnter={showTooltipIfTruncated}
                    onMouseLeave={hideTooltip}
                    onMouseDown={hideTooltip}
                >
                    {text}
                </span>
            </TooltipTrigger>
            <TooltipContent className={styles.tooltip}>{text}</TooltipContent>
        </Tooltip>
    )
}
